import React from "react"
import { padStart } from "lodash"

const ellipsis = (string, count) => {
  if (string && string.length <= count) {
    return string
  }
  return `${string.slice(0, count).trim()}...`
}

const formatDuration = duration => {
  return `${Math.floor(duration / 1000 / 60)}:${padStart(
    Math.floor(duration / 1000) % 60,
    2,
    "0"
  )}`
}

// List of songs
const Tracks = ({ tracks }) => {
  return (
    <div style={{ width: "357px", padding: "0px" }}>
      <table
        style={{ borderCollapse: "collapse", padding: "0px", width: "357px" }}
      >
        <tbody>
          <tr>
            <td
              style={{
                backgroundColor: "black",
                background: "black",
                width: "357px",
                height: "10px",
                padding: "0px",
                border: 0
              }}
            ></td>
          </tr>
        </tbody>
      </table>
      <table
        style={{
          borderCollapse: "collapse",
          padding: "0px",
          width: "357px",
          backgroundColor: "black"
        }}
      >
        <tbody>
          {tracks &&
            tracks.map((track, index) => {
              if (index > 4) return null
              return (
                <tr key={track.name}>
                  <td
                    style={{
                      backgroundColor: "black",
                      background: "black",
                      padding: "0px 8px 8px",
                      width: "15px",
                      color: "rgb(128,128,128)",
                      fontFamily: "system-ui",
                      fontSize: "12px"
                    }}
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      backgroundColor: "black",
                      background: "black",
                      padding: "0px 8px 8px",
                      width: "279px",
                      color: "rgb(211,211,211)",
                      fontFamily: "system-ui",
                      fontSize: "12px"
                    }}
                  >
                    {ellipsis(track.name, 35)}
                  </td>
                  <td
                    style={{
                      backgroundColor: "black",
                      background: "black",
                      padding: "0px 8px 8px",
                      width: "36px",
                      textAlign: "right",
                      color: "rgb(128,128,128)",
                      fontFamily: "system-ui",
                      fontSize: "12px"
                    }}
                  >
                    {formatDuration(track.duration)}
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}

export default Tracks
